import { gdprManagerRequest } from '../../config/auth';
import msalInstance from './auth';

/**
 * Attempts to get a token silently and if silent fails attempts using popup.
 *
 * @returns `[token, error]: [string | null, unknown]`
 */
async function getTokenFromServiceClient(): Promise<string | null> {
  let token = null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...gdprManagerRequest,
      account: msalInstance.getAllAccounts()[0],
    });
    token = response.accessToken;
  } catch (err) {
    if (err) {
      try {
        const response = await msalInstance.acquireTokenPopup(gdprManagerRequest);
        token = response.accessToken;
      } catch (err) {
        /** Something went wrong and all token acquisitions failed, clear storage and redirect to login */
        window.sessionStorage.clear();
        window.location.replace('/');
      }
    }
  }

  return token;
}

export default getTokenFromServiceClient;
